module.exports = __webpack_public_path__ + "img/1F915.2e882dc4.svg";